module.exports = __webpack_public_path__ + "img/google-logo.c21ca9d1.svg";